import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/History_of_Sci_&_Tech_-_Industrial_Innovations.png';

function HistoryPageIndustrialInnovationsGo() {
  return (
    <QuizPage
      title="History: Industrial Innovations"
      subTopic="Industrial Innovations"
      backgroundImage={historyImage}
      returnPath="/History-Industrial-Innovations"
    />
  );
}

export default HistoryPageIndustrialInnovationsGo;
